// export the queries used by the tabs of the activity panel so that they
// can be auto-reloaded (by query name) as other things on the case page
// are updated...

export {
  NAME as CALL_HISTORY_QUERY,
} from './CallHistory/withCallHistory/caseCallHistoryQuery';

export { NAME as CASE_NOTES_QUERY } from './Notes/withCaseNotes/caseNotesQuery';

export {
  NAME as STATUS_UPDATES_QUERY,
} from './StatusUpdates/withCaseStatusHistory/caseStatusHistoryQuery';



// WEBPACK FOOTER //
// ./src/compositions/CaseActivityPanel/queries.js